import { Collapse, Dropdown, Modal, Popover, Tooltip, Toast } from 'bootstrap';
import Cookies from 'js-cookie';
import d3 from 'd3';
import { initToastr } from '../modules/toast.js';
import registerD3Tip from '../vendor/d3.tip.js';

import '../vendor/vanilla-cookieconsent.js';

// Loaded on every layout via site.js. Turbo Drive does not re-run inline head scripts
// on login navigation (logged-out home → logged-in application), so this cannot live
// only in application.html.erb.
globalThis.__siteBundleQueue = globalThis.__siteBundleQueue || [];
globalThis.runWhenSiteBundleReady = globalThis.runWhenSiteBundleReady || function (fn) {
  if (globalThis.__siteBundleReady) fn();
  else globalThis.__siteBundleQueue.push(fn);
};

initToastr();

globalThis.d3 = d3;
globalThis.Cookies = Cookies;
globalThis.bootstrap = { Collapse, Dropdown, Modal, Popover, Tooltip, Toast };

registerD3Tip(d3);
